let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("h4u0O")]).then(() => parcelRequire('95zUF'));